var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatePickerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11243",
    "data-name": "Group 11243",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.365,
    height: 20.363,
    viewBox: "0 0 20.365 20.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4122",
    "data-name": "Rectangle 4122",
    width: 20.365,
    height: 20.363,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11242",
    "data-name": "Group 11242",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M5.093,1.455c0-.247,0-.481,0-.716A.715.715,0,0,1,5.819,0a.724.724,0,0,1,.725.744c0,.231,0,.462,0,.7h7.27c0-.029.006-.061.006-.094,0-.212,0-.424,0-.636A.714.714,0,0,1,14.548,0a.725.725,0,0,1,.725.722c0,.238,0,.477,0,.732h.136q1.364,0,2.727,0a2.064,2.064,0,0,1,1.188.32,2.121,2.121,0,0,1,1.02,1.658c.011.155.019.31.019.465q0,7.125,0,14.25a2.146,2.146,0,0,1-1.1,1.938,2.343,2.343,0,0,1-1.227.276q-4.153,0-8.307,0-3.693,0-7.387,0a2.255,2.255,0,0,1-1.766-.736A2.217,2.217,0,0,1,0,18.087Q0,10.853,0,3.62A2.156,2.156,0,0,1,2,1.479c.426-.027.855-.02,1.283-.022.6,0,1.2,0,1.813,0M1.453,8V18.046c0,.034,0,.068,0,.1a.723.723,0,0,0,.481.7,1.363,1.363,0,0,0,.447.058q7.812,0,15.625,0a.692.692,0,0,0,.136,0,1.574,1.574,0,0,0,.349-.086.763.763,0,0,0,.422-.778q0-4.96,0-9.92V8ZM6.544,2.911c0,.141,0,.269,0,.4a3.932,3.932,0,0,1-.023.441.737.737,0,0,1-.672.609.725.725,0,0,1-.693-.475,1.379,1.379,0,0,1-.06-.367c-.01-.2,0-.4,0-.6a.215.215,0,0,0-.042-.011c-.947,0-1.894-.006-2.841,0a.719.719,0,0,0-.72.536,1.433,1.433,0,0,0-.036.337c0,.882,0,1.765,0,2.647,0,.036,0,.073.005.109H18.913V6.4q0-1.045,0-2.091c0-.212,0-.424,0-.636a.711.711,0,0,0-.428-.68,1.1,1.1,0,0,0-.419-.08c-.9-.007-1.8,0-2.7,0-.025,0-.051,0-.085.006,0,.135,0,.263,0,.391a3.991,3.991,0,0,1-.022.441.706.706,0,0,1-1.377.111,1.471,1.471,0,0,1-.05-.358c-.008-.195,0-.391,0-.588Z",
    transform: "translate(0 -0.001)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M61.835,181.7c-.268,0-.538.018-.8,0a.691.691,0,0,1-.622-.7.679.679,0,0,1,.633-.681c.532-.02,1.066-.02,1.6,0a.7.7,0,0,1,.642.67.723.723,0,0,1-.631.719,1.048,1.048,0,0,1-.134.02c-.227,0-.454,0-.682,0,0-.007,0-.014,0-.021",
    transform: "translate(-56.747 -169.369)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M145.838,181.7c-.268,0-.538.018-.8,0a.691.691,0,0,1-.625-.713.68.68,0,0,1,.642-.673c.532-.019,1.066-.02,1.6,0a.694.694,0,0,1,0,1.383c-.269.026-.543,0-.815,0h0",
    transform: "translate(-135.656 -169.368)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M229.835,181.7c-.272,0-.546.02-.815,0a.69.69,0,0,1-.611-.714.678.678,0,0,1,.632-.67c.532-.02,1.066-.02,1.6,0a.7.7,0,0,1,.643.669.723.723,0,0,1-.63.72,1.035,1.035,0,0,1-.134.02c-.227,0-.454,0-.682,0,0-.007,0-.015,0-.022",
    transform: "translate(-214.564 -169.37)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M61.838,241.7c-.268,0-.538.018-.8,0a.691.691,0,0,1-.625-.713.678.678,0,0,1,.641-.673c.532-.02,1.066-.02,1.6,0a.7.7,0,0,1,.634.688.725.725,0,0,1-.628.7,1.006,1.006,0,0,1-.134.02c-.227,0-.454,0-.682,0,0-.007,0-.014,0-.021",
    transform: "translate(-56.748 -225.726)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M145.837,241.752c-.3-.02-.6-.017-.891-.066a.693.693,0,0,1,.078-1.363c.543-.021,1.089-.022,1.632,0a.694.694,0,0,1,0,1.383c-.27.023-.544,0-.816,0v.04",
    transform: "translate(-135.66 -225.742)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M229.834,241.755c-.294-.019-.591-.015-.88-.063a.693.693,0,0,1,.075-1.365c.54-.02,1.081-.021,1.62,0a.71.71,0,0,1,.64.662.721.721,0,0,1-.627.721c-.273.025-.551,0-.827,0Z",
    transform: "translate(-214.569 -225.746)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerIcon);
export default __webpack_public_path__ + "static/media/date-picker-icon.0c4b6ff0ba70f67f008d0bac7433181e.svg";
export { ForwardRef as ReactComponent };